import { useRouter } from 'next/router';
import { getRouterLocale } from './i18Utils/constant';
import queryString from 'query-string';
import { getQueryStrings } from './helper';
import {
  getbaseRoute,
  resolveGullackURL,
} from '../components/OrderSuccessPageNew/utils';
import { forceNavigateToReactPage } from '../components/OrderSuccessPageNew/utils';
import {
  androidIsAppUser,
  getAndroidAppPageInstance,
  isAndroidOpenDeeplink,
} from './androidUtils';

export function forceNavigateToPage(navigationUrl) {
  // check if android app user and is opening Web app from Bottom sheet
  if (
    androidIsAppUser() &&
    getAndroidAppPageInstance() == 'VideoRoundedBottomFragment'
  ) {
    let navUrl = navigationUrl;
    isAndroidOpenDeeplink('61', resolveGullackURL(navUrl));
  } else {
    window.location.href = navigationUrl;
  }
}

export function useNavigation() {
  const router = useRouter();

  const navigateToPdp = (webUrl) => {
    let url = webUrl + window?.location?.search;
    router.push(url);
  };
  const navigateToCategory = (value) => {
    if (value?.includes('category')) {
      let redirectUrl = value;
      if (value?.includes('category_all')) {
        redirectUrl = value;
      } else if (value?.includes('category_tab')) {
        redirectUrl = replaceTabWithAll(redirectUrl);
      } else if (value?.includes('/')) {
        let categoryId = value?.split('/').pop();
        redirectUrl = `category_all_${categoryId}`;
      }
      let url = `/category/${redirectUrl}`;
      return url;
      // let url =
      //     `/store/${redirectUrl}` + window?.location?.search;
    } else {
      return value;
    }
  };
  const viewAllClickHandler = (value) => {
    let redirectUrl = `category_all_${value}`;
    if (value) {
      if (value?.includes('category_all')) {
        redirectUrl = value;
      }
      return `/category/${redirectUrl}`;
    }
  };
  const categoryClickHandler = (category) => {
    let url = getCategoryRedirectUrl(category);
    router.push(url, '', {
      locale: getRouterLocale(router),
    });
  };
  const navigateToOrderInfo = (id, searchParams = {}) => {
    let params = window?.location?.search;
    if (params !== '') {
      if (searchParams) {
        params = params + queryString.stringify(searchParams);
      }
    } else {
      params = '?' + queryString.stringify(searchParams);
    }
    params = getQueryStrings(params.replace('?', ''));
    params = '?' + queryString.stringify(params);
    forceNavigateToReactPage(`${getbaseRoute()}orderinfo/${id}` + params);
  };

  const navigateToCheckoutPage = (searchParams = {}, data = {}) => {
    // code to fix params issue
    let params = window?.location?.search;
    if (params !== '') {
      if (searchParams) {
        params = params + queryString.stringify(searchParams);
      }
    } else {
      params = '?' + queryString.stringify(searchParams);
    }
    // code to fix params issue
    params = getQueryStrings(params.replace('?', ''));
    params = '?' + queryString.stringify(params);

    forceNavigateToReactPage(`${getbaseRoute()}checkout` + params, data);
  };
  const navigateToPage = (navigationUrl, searchParams = {}) => {
    let params = '';
    if (searchParams) {
      params = params + '?' + queryString.stringify(searchParams);
    }
    forceNavigateToPage(navigationUrl + params);
  };

  return {
    navigateToPdp,
    navigateToCategory,
    viewAllClickHandler,
    categoryClickHandler,
    navigateToOrderInfo,
    navigateToCheckoutPage,
    navigateToPage,
    // navigateToOrderSuccess,
  };
}
